"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "verditype", {
    enumerable: true,
    get: function() {
        return verditype;
    }
});
var verditype = {
    // Benyttes for transformer som har flere verdier som parameter
    flere: "flere",
    // Benyttes for transformer som har én enkelt verdi som parameter
    enkelt: "enkelt",
    // Benyttes for transformere som trenger transformerte verdier som del av annen tekst
    formatertTekst: "formatertTekst"
};
